import { useLocation } from 'react-router-dom';
import React from 'react';
import { DropdownButton } from 'react-bootstrap';
import { Link } from '../../Link.jsx';
import { DeleteBlueIcon } from '../../icons/DeleteBlueIcon.jsx';
import { EditBlueIcon } from '../../icons/EditBlueIcon.jsx';
import { PlusButtonBlueIcon } from '../../icons/PlusButtonBlueIcon.jsx';
import { SignOutIcon } from '../../icons/SignOutIcon.jsx';
import { TemplateBlueIcon } from '../../icons/TemplateBlueIcon.jsx';
import {
  AddRoleLink,
  EditUserLink,
  PermissionsLink,
  UserLink,
} from '../../links/index.jsx';
import { EyeIcon } from '../../icons/EyeIcon.jsx';
import { getOrgSlug } from '../../../lib/utils.js';
import CustomMenuItem from '../../CustomMenuItem.jsx';

const UserActionsDropdown = ({
  currentUserRole,
  orgRole,
  userId,
  currentUserId,
  employeeId,
  onDelete,
  onSignOut,
}) => {
  const location = useLocation();
  const route = location.pathname;
  const slug = getOrgSlug();

  const EditButton = ({ children }) =>
    userId !== currentUserId ? (
      <EditUserLink userId={userId}>{children}</EditUserLink>
    ) : (
      <Link route="organization/users/edit" params={{ userId, slug }}>
        {children}
      </Link>
    );

  const ViewPermissionsButton = ({ children }) =>
    userId !== currentUserId ? (
      <PermissionsLink userId={userId}>{children}</PermissionsLink>
    ) : (
      <Link
        route="organization/users/permissions/show"
        params={{ userId, slug }}
      >
        {children}
      </Link>
    );

  return (
    <div className="actions">
      <DropdownButton
        noCaret
        title=""
        id="id"
        className="btn-more btn btn-default"
      >
        {route !== '/organization/users/show' ? (
          <UserLink userId={userId}>
            <CustomMenuItem>
              <span className="flex">
                <EyeIcon />
                <span>&nbsp; View</span>
              </span>
            </CustomMenuItem>
            <CustomMenuItem divider />
          </UserLink>
        ) : null}

        <EditButton>
          <CustomMenuItem>
            <span className="flex">
              <EditBlueIcon />
              <span>&nbsp; Edit</span>
            </span>
          </CustomMenuItem>
          <CustomMenuItem divider />
        </EditButton>

        {userId !== currentUserId &&
        employeeId &&
        currentUserRole !== 'leader' ? (
          <AddRoleLink userId={userId}>
            <span>
              <CustomMenuItem>
                <span className="flex">
                  <PlusButtonBlueIcon />
                  <span>&nbsp;Add New Role</span>
                </span>
              </CustomMenuItem>
              <CustomMenuItem divider />
            </span>
          </AddRoleLink>
        ) : null}

        {employeeId && currentUserRole !== 'leader' ? (
          <ViewPermissionsButton>
            <span>
              <CustomMenuItem>
                <span className="flex">
                  <TemplateBlueIcon />
                  <span>&nbsp;View Permissions</span>
                </span>
              </CustomMenuItem>
              <CustomMenuItem divider />
            </span>
          </ViewPermissionsButton>
        ) : null}

        {userId !== currentUserId &&
        (currentUserRole === 'admin' ||
          (currentUserRole === 'consultant' && orgRole !== 'admin')) ? (
          <span>
            <CustomMenuItem onClick={() => onDelete(userId)}>
              <span className="flex">
                <DeleteBlueIcon />
                <span>&nbsp; Delete</span>
              </span>
            </CustomMenuItem>
            <CustomMenuItem divider />
          </span>
        ) : null}
        {userId === currentUserId ? (
          <CustomMenuItem onClick={onSignOut}>
            <span className="flex">
              <SignOutIcon />
              <span>&nbsp; Sign Out</span>
            </span>
          </CustomMenuItem>
        ) : null}
      </DropdownButton>
    </div>
  );
};

export default UserActionsDropdown;
